/**
 * Created by liux on 18/3/25.
 * app预定了 公共的baseStore 如下：
 state: {
    pageTitle: '',
    loginState: true,
    appReady: true,
    appInfo: {
      app: true,
      language: '',
      macId: '',
      os: '',
      osVersion: '',
      softVersion: '',
    },
    ajaxState: {
      flag: false,
      tip: '',
    },
    pageTranSet: {
      popState: false,
      transitionType: 'fade',
      transitionMode: 'out-in',
    },
}*/


export default {
  state: {}
}
